import React from "react";
import {
  Header,
  Nav,
  AboutComp,
  ExperienceComp,
  Projects,
  ContactComp,
  Footer,
} from "./Components";

const App = () => {
  return (
    <>
      <Header />
      <Nav />
      <AboutComp />
      <ExperienceComp />
      <Projects />
      <ContactComp />
      <Footer />
    </>
  );
};

export default App;
